import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const InfoCard = ({ title, children, grow }) => (
  <Card
    sx={{
      flexGrow: grow ? 1 : undefined,
      borderRadius: 4,
      background: 'linear-gradient(180deg, #ffffff 0%, #fafafa 100%)',
      boxShadow: '0 4px 18px rgba(0,0,0,0.05)',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <CardContent sx={{ flexGrow: 1 }}>
      <Typography variant="title2" fontWeight={600} gutterBottom>
        {title}
      </Typography>
      {title && <Divider sx={{ mb: 2 }} />}
      <Stack spacing={1}>{children}</Stack>
    </CardContent>
  </Card>
)

export default InfoCard
